/** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * MODULE: Api.js
 * Author: SE EMK
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* -------------------------------- Imports --------------------------------- */
import axios from 'axios'

/* ------------------------------ Definitions ------------------------------- */
/* ------------------------------- Functions -------------------------------- */
/* --------------------------------- Body ----------------------------------- */
/* -------------------------------- Exports --------------------------------- */
export default () => {
  return axios.create({
    baseURL: process.env.API_SERVER_BASE_URL || `http://localhost:6066`
  })
}



// WEBPACK FOOTER //
// ./src/services/Api.js